module Meevo.Components.Controls {
    export class AddCreditPaymentAccountController {
        static $inject = [
            '$mdDialog',
            '$q',
            '$rootScope',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.hostedPage.HostedPageService',
            'meevo.components.busy.BusyService',
            'zipCode',
            'useHostedPage',
            'paymentAccountId',
            'merchantAccountId',
            'merchantProviderId',
            'merchantTerminalId',
            'clientId',
            'isHsaFsa',
            'showHsaFsa',
            'showHsaFsaAfterAccountCreation',
            'hostedPageIntent',
            'paymentAccountType',
            'forceManualEntry',
            'isHostedPageAutomaticallySwitch',
        ];

        private readonly hostedPageId: Meevo.Model.HostedPageIdType = 'HostedPageAddCreditPaymentAccount';
        private hostedPageTerminal: Meevo.Model.MerchantTerminal;

        constructor(
            private mdDialog: ng.material.IDialogService,
            private $q: angular.IQService,
            private $rootScope: angular.IRootScopeService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private hostedPageService: Meevo.Components.HostedPage.IHostedPageService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private zipCode: string,
            private useHostedPage: boolean,
            private paymentAccountId: any,
            private merchantAccountId: any,
            private merchantProviderId: number,
            private merchantTerminalId: any,
            private clientId: Guid,
            private isHsaFsa: boolean,
            private showHsaFsa: boolean,
            private showHsaFsaAfterAccountCreation: boolean,
            private hostedPageIntent: Meevo.Model.HostedPageIntent,
            private paymentAccountType: Meevo.Model.PaymentAccountTypeEnum,
            private forceManualEntry: boolean,
            private isHostedPageAutomaticallySwitch: boolean
        ) {
        }

        cancel() {
            let promise = this.isHostedPageActive() && this.paymentAccountId ?
                this.dataService.customMethodData(`/api/paymentaccount/${this.paymentAccountId}`, "delete", {
                isHostedPageSetup: true
            }) : this.$q.resolve();
            promise.finally(() => {
                this.hostedPageService.reset(this.hostedPageId);
                this.mdDialog.cancel({
                    hostedPageTerminal: this.hostedPageTerminal,
                });
            })
        }

        close(paymentResponse = null) {
            this.mdDialog.hide({
                zipCode: this.zipCode,
                paymentResponse: paymentResponse,
                isHsaFsa: this.isHsaFsa,
                hostedPageTerminal: this.hostedPageTerminal,
            });
        }

        submit(isValid) {
            if (isValid) {
                if (this.useHostedPage) {
                    this.hostedPageSave();
                } else {
                    this.terminalSave();
                }
            }
        }

        terminalSave() {
            const request = {
                merchantTerminalId: this.merchantTerminalId,
                merchantAccountId: this.merchantAccountId,
                paymentAccountType: this.paymentAccountType,
                zipCode: this.zipCode,
                isHsaFsa: this.isHsaFsa,
                forceManualEntry: this.forceManualEntry,
                clientGlobalId: this.clientId,
            };
            const uri = "api/paymentAccount";

            const deferred = this.$q.defer();

            this.busyService.start("Waiting for swipe...");

            this.dataService.customMethodData(uri, "POST", request, { skipInterceptor: true })
                .then((response: any) => {
                    this.busyService.stop();
                    this.close(response.data);
                    deferred.resolve(response.data);
                })
                .catch((error: any) => {
                    this.busyService.stop();

                    const showErrorMessage = () => {
                        //Need to cancel prior to possibly showing error alert so that dialog's promise is cleaned up
                        this.mdDialog.cancel();
                        this.modalService.alert(error.data.responseStatus.message);
                        deferred.reject();
                    };

                    if (this.isHostedPageAutomaticallySwitch) {
                        let isHostedPageSwitchError = false;
                        switch (error.data.responseStatus.message) {
                            case "MESSAGE_CC_STATUS_PROCESSORCOMMUNICATIONERROR":
                            case "MESSAGE_CC_STATUS_REQUESTTIMEOUT":
                            case "MESSAGE_CC_STATUS_TIMEOUT":
                                isHostedPageSwitchError = true;
                                break;
                        }

                        if (isHostedPageSwitchError) {
                            const url = `api/merchantAccount/${this.merchantAccountId}/devices/list`;
                            const request = {
                                criteria: {
                                    isHostedMode: true,
                                }
                            };
                            return this.dataService.customMethodData(url, "POST", request)
                                .then((response: any) => {
                                    const hostedPageTerminal = response.data.find(terminal => terminal.merchantTerminalType === Model.MerchantTerminalTypeEnum.Hosted);
                                    if (!hostedPageTerminal) {
                                        showErrorMessage();
                                        return;
                                    }
                                    this.hostedPageTerminal = hostedPageTerminal;
                                    this.$rootScope.$broadcast(Components.Common.Messages.REGISTER_TERMINAL_UPDATE, {}, hostedPageTerminal);
                                    this.$rootScope.$broadcast(Components.Common.Messages.DRAWER_TERMINAL_UPDATE, {}, hostedPageTerminal.id);
                                    this.hostedPageSave()
                                        .then(() => deferred.resolve())
                                        .catch(() => deferred.reject());
                                })
                                .catch(() => {
                                    showErrorMessage();
                                });
                        }
                    }

                    showErrorMessage();
                });

            return deferred.promise;
        }

        isHostedPageActive() {
            return this.hostedPageService.getHostedPageActive(this.hostedPageId);
        }

        hostedPageError(response) {
            if (response.status == 409) { // conflict
                this.modalService.alert(response.data.responseStatus.message);
            }
        }

        hostedPageSave() {
            const request: Meevo.Components.HostedPage.IHostedPageRequest = {
                paymentAccountId: this.paymentAccountId,
                merchantAccountId: this.merchantAccountId,
                merchantProviderId: this.merchantProviderId,
                isCardOnFile: true,
                billingPostalCode: this.zipCode,
                billingPostalCodeRequired: false,
                clientId: this.clientId,
                paymentAccountTokenCreatedCallback: (paymentAccountId) => {
                    this.paymentAccountId = paymentAccountId;
                },
                isHsaFsa: this.isHsaFsa,
                hostedPageIntent: this.hostedPageIntent
            };

            const deferred = this.$q.defer();

            this.hostedPageService.process(request, this.hostedPageId)
                .then((response: any) => {
                    this.close(response);
                    deferred.resolve(response);
                })
                .catch((response: any) => {
                    //Need to cancel prior to possibly showing error alert so that dialog's promise is cleaned up
                    this.mdDialog.cancel();
                    this.hostedPageError(response);
                    deferred.reject();
                });

            return deferred.promise;
        }
    }

    angular.module("meevo.components.controls")
        .controller("meevo.components.controls.AddCreditPaymentAccountController", AddCreditPaymentAccountController);
}